<template>

  <div v-if="ay_list != null">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Copy Time Table Slots</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <!-- <v-card-title>
            <h3>Copy Time Table Slots </h3>
        </v-card-title> -->
      <!-- <v-card-text> -->
      <v-container>
        <v-row dense>
          <v-col cols="12" sm="2" md="2">
            <v-combobox rounded dense required v-model="from_ay" :items="ay_list" label="From Academic Year" outlined />
          </v-col>

          <v-col cols="12" sm="2" md="2" v-if="version_master_list.length > 0">
            <v-combobox rounded dense required v-model="from_version" :items="version_master_list"
              item-text="version_name" item-value="id" label="From Version" outlined />
          </v-col>
          <v-col cols="12" sm="2" md="2" style="text-align: center">
            <v-btn text color="#0f2027" :loading="copy_btn_load" @click="saveCopySlot">
              <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-combobox rounded dense required v-model="to_ay" :items="ay_list" label="To Academic Year" outlined />
          </v-col>
          <v-col cols="12" sm="2" md="2" v-if="version_master_list.length > 0">
            <v-combobox rounded dense required v-model="to_version" :items="version_master_list"
              item-text="version_name" item-value="id" label="To Version" outlined />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col v-if="from_slot_list != null" cols="12" sm="6" md="6" style="text-align: left">
            <v-toolbar flat dense class="toolbar">
              From [AY : {{ from_ay }}]
              <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-data-table :headers="headers" dense class="elevation-1 mytable" :items="from_slot_list"
              :search="search"></v-data-table>
          </v-col>
          <v-col v-if="to_slot_list != null" cols="12" sm="6" md="6" style="text-align: left">
            <v-toolbar flat dense class="toolbar">
              To [AY : {{ to_ay }}]
              <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-data-table :headers="headers" :items="to_slot_list" dense class="elevation-1 mytable"
              :search="search"></v-data-table>
          </v-col>
        </v-row>
      </v-container>
      <!-- </v-card-text> -->
    </v-card>
  </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    ay_list: null,
    to_ay: null,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    from_version: null,
    to_version: null,
    from_ay: null,
    from_slot_list: null,
    to_slot_list: null,
    headers: [
      { text: "Stream", value: "stream" },
      { text: "Slot No", value: "slot_no" },
      { text: "Start Time", value: "start_time" },
      { text: "End Time", value: "end_time" },
      { text: "Slot Type", value: "slot_type" },
    ],
    search: "",
    version_master_list:[],
    copy_btn_load: false,
  }),
  watch: {
    to_ay() {
      if (this.to_ay != null && this.to_version != null) {
        this.getSlot(this.to_ay, this.to_version, "to");
      }
    },

    to_version() {
      if (this.to_ay != null && this.to_version != null) {
        this.getSlot(this.to_ay, this.to_version, "to");
      }
    },

    from_ay() {
      if (this.from_ay != null && this.from_version != null) {
        this.getSlot(this.from_ay, this.from_version, "from");
      }
    },

    from_version() {
      if (this.from_ay != null && this.from_version != null) {
        this.getSlot(this.from_ay, this.from_version, "from");
      }
    },
  },
  methods: {
    getSlot(ay, version_id, to_from) {
      if (to_from == "to") this.to_slot_list = null;
      else if (to_from == "from") this.from_slot_list = null;

      const formData = {
        ay: ay,
        timetableversionmaster_id: version_id.id,
      };

      axios
        .post("/timeTable/getSlot", formData)
        .then((res) => {
          if (to_from == "to") {
            this.to_slot_list = res.data.slot_list;
          } else if (to_from == "from") {
            this.from_slot_list = res.data.slot_list;
          }
        })
        .catch((error) => {
          alert("Something went wrong!!!");
          window.console.log(error);
        })
        .finally(() => {
        });
    },
    saveCopySlot() {
      if (this.from_ay == null || this.to_ay == null) {
        alert("Please select Academic year!!!");
        return;
      }

      if (this.from_ay == this.to_ay && this.from_version == this.to_version) {
        alert("From and To Academic year and Version cannot be same!!!");
        return;
      }

      this.copy_btn_load = true;

      const formData = {
        from_ay: this.from_ay,
        to_ay: this.to_ay,
        from_version_id: this.from_version.id,
        to_version_id: this.to_version.id,
      };

      axios
        .post("/timeTable/copySlot", formData)
        .then((res) => {
          this.to_slot_list = res.data.slot_list;
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.copy_btn_load = false;
        });
    },
    copySlot() {
      axios
        .post("/timeTable/init_slot")
        .then((res) => {
          this.to_ay = res.data.curr_ay;
          this.ay_list = res.data.ay_list;
          this.version_master_list = res.data.version_master_list;
          this.from_ay = res.data.curr_ay;
          var index = this.ay_list.indexOf(this.to_ay) - 1;
          if (index < 0) index = 0;
          this.from_ay = this.ay_list[index];
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.copy_offer_btn_load = false;
        });
    },
  },
  mounted() {
    this.copySlot();
  },
};
</script>
<style scoped></style>
